import { giftIsValid } from 'src/utils/gift/giftIsValid';

export const validGifts = giftIsValid;
